export class Reason {
  public id?: string;
  public reason_code: string;
  public short_description?: string;
  public description: string;
  public sign_pid?: any;
  public type_pid?: any;
  public signDescription?: string;
  public typeDescription?: string;
}




// WEBPACK FOOTER //
// ./src/app/models/loyalty-reason.model.ts